module.exports = __webpack_public_path__ + "static/media/avatarDefault.836abfe9.png";